export const isEmpty = (o: object) => {
  return Object.keys(o).length === 0;
};

export default isEmpty;
